import type { ComponentSchema } from '../../../../../schema-types'
import { schema as headerSchema } from './header.schema'
import {
  bannerCarouselSchema,
  categoryBentoSchema,
  comboSpotlightSchema,
  corporateBandSchema,
  productRailSchema,
  promisesSchema,
  reviewsSchema,
  storySchema,
} from './library.schema'
import { schema as lookbookBannerSchema } from './lookbook-banner.schema'
import { schema as productDetailSchema } from './product-detail.schema'
import { schema as signinSchema } from './signin.schema'
import { schema as signupSchema } from './signup.schema'

/**
 * Nakshi's own schemas (additive fields its markup reads), layered over apparels3BaseSchemas.
 * `chrome` may replace headerSchema, footerSchema, floatingButtonsSchema or mobileNavSchema.
 */
export const nakshiSchemas: {
  componentSchemas: Record<string, ComponentSchema>
  chrome: Partial<Record<'headerSchema' | 'footerSchema' | 'floatingButtonsSchema' | 'mobileNavSchema', ComponentSchema>>
} = {
  componentSchemas: {
    'banner-carousel': bannerCarouselSchema,
    'category-bento': categoryBentoSchema,
    'combo-spotlight': comboSpotlightSchema,
    'corporate-band': corporateBandSchema,
    'product-rail': productRailSchema,
    promises: promisesSchema,
    reviews: reviewsSchema,
    story: storySchema,
    'lookbook-banner': lookbookBannerSchema,
    'product-detail': productDetailSchema,
    signin: signinSchema,
    signup: signupSchema,
  },
  chrome: {
    headerSchema,
  },
}
